/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Collapse } from 'antd'
import dateFormat from 'dateformat'
import { ArrDayText } from '@game/util'
import { CircleDownIco } from '@shared/Icon/ArrowIcon'
import { formatNumber, getRatioTicketMoney } from '@utils/utils'
import { Schema$RecordUserAsset, Schema$RecordUserMoney } from '@protocol/bank'
import { PROPERTY_CHARGE_TYPE, PROPERTY_CONSUME_TYPE, PROPERTY_ID, PROPERTY_MOVE_TYPE } from 'adv-protocol/src/GameCommon'
import { getIconByPropertyId } from '@utils/jsxutils'
import useRootStore from '@store/useRootStore'
import { ADMIN_PROPERTY_CHARGE_TYPE_DESC_DEFAULT_TEXT, ADMIN_PROPERTY_CONSUME_TYPE_DESC_DEFAULT_TEXT } from '@v2/constants/common'
import { Gain, Lose, MoneyHistoryItemWrap } from '../index.style'
import MoneyHistoryListItemContent from '../MoneyHistoryListItemContent'


const ShowList = (
  <CircleDownIco/>
)

interface MoneyHistoryListItemProps {
  propertyId: PROPERTY_ID
  track: Schema$RecordUserAsset | Schema$RecordUserMoney
}

const makeDesc = (propertyId: PROPERTY_ID, trackParam: Schema$RecordUserAsset | Schema$RecordUserMoney) => {
  const { subType } = trackParam
  let { desc } = trackParam

  if (propertyId === PROPERTY_ID.CASH
    || propertyId === PROPERTY_ID.MONEY
    || propertyId === PROPERTY_ID.HEART) {
    switch (subType) {
      case PROPERTY_CONSUME_TYPE.ADMIN:
        desc = ADMIN_PROPERTY_CONSUME_TYPE_DESC_DEFAULT_TEXT
        break
      case PROPERTY_CHARGE_TYPE.ADMIN:
        desc = ADMIN_PROPERTY_CHARGE_TYPE_DESC_DEFAULT_TEXT
        break
    }
  }

  return desc
}

function MoneyHistoryListItem(props: MoneyHistoryListItemProps) {
  const { bankStore } = useRootStore()
  const { propertyId, track } = props

  const { diffDate, setDiffDate } = bankStore
  const dateHappen = new Date(track.dateHappen)
  const uiAmount = track.productId === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(track.amount) : track.amount
  let isDiffDate: boolean
  if (diffDate === null) {
    setDiffDate(dateHappen)
    isDiffDate = true
  } else if (dateFormat(diffDate, 'mm/dd') !== dateFormat(dateHappen, 'mm/dd')) {
    setDiffDate(dateHappen)
    isDiffDate = true
  } else {
    isDiffDate = false
  }

  let isContent = false
  if (track.moveType === PROPERTY_MOVE_TYPE.CHARGE) {
    switch (track.subType) {
      case PROPERTY_CHARGE_TYPE.BETTOR_BETTING_HIT:
      case PROPERTY_CHARGE_TYPE.BETTOR_BETTING_CANCEL:
      case PROPERTY_CHARGE_TYPE.BETTOR_BETTING_EXCEPTION:
      case PROPERTY_CHARGE_TYPE.BETTOR_ODDS_CANCEL:
        isContent = true
        break
    }
  }

  let content = null
  if (isContent && track.betHistoryContent) {
    content = <MoneyHistoryListItemContent contents={track.betHistoryContent}/>
  }

  let amount
  if (track.moveType === PROPERTY_MOVE_TYPE.CONSUME) {
    amount = (
      <div className="money-history-list--wrap num">
        <span className="money-history-list--wrap--num" css={Lose}>- {formatNumber(uiAmount)}</span>
        {getIconByPropertyId(propertyId)}
      </div>
    )
  } else {
    amount = (
      <div className="money-history-list--wrap num">
        <span className="money-history-list--wrap--num" css={Gain}>+ {formatNumber(uiAmount)}</span>
        {getIconByPropertyId(propertyId)}
      </div>
    )
  }

  let date = null
  if (isDiffDate) {
    date = (
      <div className="date-wrap" key={dateHappen.valueOf()}>
        {dateFormat(dateHappen, 'mm/dd')}({ArrDayText[dateHappen.getDay()]})
      </div>
    )
  }

  const itemDesc = makeDesc(propertyId, track)
  const header = (
    <div className="money-history-list">
      <div className="money-history-list--wrap">
        <span className="money-history-list--wrap--time">{dateFormat(dateHappen, 'HH:MM:ss')}</span>
        <span className="money-history-list--wrap--txt">{itemDesc}</span>
        {content !== null ? ShowList : null}
      </div>
      {amount}
    </div>
  )

  return (
    <MoneyHistoryItemWrap>
      {date}
      <Collapse bordered={false} defaultActiveKey="0">
        <Collapse.Panel key={track.id} header={header} showArrow={false} disabled={content === null}>
          {content}
        </Collapse.Panel>
      </Collapse>
    </MoneyHistoryItemWrap>
  )
}

export default MoneyHistoryListItem
